<template>
  <div class="p-form-zipcode">
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
.p-form-zipcode {
  width: rem(96);
}
</style>
